import { ProspectoCab } from './../../../models/ProspectoCab';
import { SolicitudDesembolsoService } from 'app/services/operaciones/solicitud-desembolso/solicitud-des.service';
import { RiesgoService } from 'app/services/riesgo/riesgo.service';
import { ProformaService } from 'app/services/operaciones/proforma/proforma.service';
import { DatePipe, DecimalPipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild, Injector } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { Router } from '@angular/router';
import { FiltrosProspecto } from 'app/models/FiltrosProspecto';
import { ItemsProspecto } from 'app/models/ItemsProspecto';
import { ItemsProspectoPropuestaOperacion } from 'app/models/ItemsProspectoPropuestaOperacion';
import { MessagesDates, MessagesGeneral, MessagesStatus, MessagesTitles } from 'app/models/messages';
import { ObservacionesRespuestaFormat } from 'app/models/ObservacionesRespuestaFormat';
import { PropuestaOperacion } from 'app/models/PropuestaOperacion';
import { EmpresasService } from 'app/services/empresas/empresas.service';
import { LoginService } from 'app/services/login/login.service';
import { PropuestaOperacionService } from 'app/services/operaciones/propuesta-operacion/propuesta-operacion.service';
import { ProspectosService } from 'app/services/operaciones/prospectos/prospectos.service';
import moment from 'moment';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import { SecurityService } from '../../../services/security/security.service';
import { FiltrosSolicitudDes } from 'app/models/FiltrosSolicitudDes';
import { ProspectoRiesgo } from 'app/models/ProspectoRiesgo';
import { environment } from 'environments/environment'; 
export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-detalle-evaluacion-operacion',
  templateUrl: './detalle-evaluacion-operacion.component.html',
  styleUrls: ['./detalle-evaluacion-operacion.component.scss'],
  providers: [DatePipe, MessagesTitles, MessagesGeneral, MessagesStatus, MessagesDates, DecimalPipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class DetalleEvaluacionOperacionComponent implements OnInit, OnDestroy {
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_Prospectos=environment.LABEL_PROSPECTOS;
  Label_Prospecto=environment.LABEL_PROSPECTO;
  Label_Proforma=environment.LABEL_PROFORMA;
  Label_Proformas=environment.LABEL_PROFORMAS;
  Label_id_soles=environment.ID_GUIA_SOLES;
  Label_id_dolares=environment.ID_GUIA_DOLARES;
  Id_Confirming=environment.ID_CONFIRMING;
  Id_Factoring=environment.ID_FACTORING;
  @ViewChild('observacionesItem', { static: false }) observacionesItem: ElementRef;
  idPropuestaOperacion: any
  estadoPropuesta: any;
  flagEvaluacion: boolean;
  loading: boolean;
  vencido: boolean;
  flagEvaluarProspecto: boolean = false;
  flagEditarProspecto: boolean = false;
  prospectoLoaded: boolean = false;
  contratoMarcoLoaded: boolean = false;
  adjuntosLoaded: boolean = false;
  pagareProvLoaded: boolean = false;
  pagareAdqLoaded: boolean = false;
  comentariosLoaded: boolean = false;
  formEvaluacion: FormGroup;
  itemsProspecto: ItemsProspecto[] = [];
  itemProspectoOtros: ItemsProspecto = new ItemsProspecto();
  PropuestaOperacion: PropuestaOperacion = new PropuestaOperacion();
  iProspectoPropuestaOperacion: ItemsProspectoPropuestaOperacion = new ItemsProspectoPropuestaOperacion();
  DTOFiltrosProspecto: FiltrosProspecto = new FiltrosProspecto();
  observacionesArrayFormat: ObservacionesRespuestaFormat;
  prospectos: ProspectoCab[] = [];
  pagareProv: any[] = [];
  pagareAdq: any[] = [];
  contratoMarco: any[] = [];
  contratoMarco1: any[] = [];
  documentosAdjuntos: any[] = [];
  itemsProspectoEvaluacion: any[] = [];
  PropuestaOperacionDetalle: any[] = [];
  bodyActualizacionDocumentos: any[] = [];
  arrProspectoPropuestaOperacion: any[] = [];
  observacionesArray: string[] = [];
  observacionesFinal: any[] = [];
  tipoServicio: number = this.Id_Factoring;
  VNPPTotal: number = 0;
  adelantoTotal: number = 0;
  interesTotal: number = 0;
  comisionTotal: number = 0;
  IGVTotal: number = 0;
  desembolsoTotal: number = 0;
  remanenteTotal: number = 0;
  bodyEvaluacion: any;
  prospecto: ProspectoRiesgo;
  user: any;
  fechaIni: any = 0;
  fechaFin: any = 0;
  contadorItemsSeleccionados: number = 0;
  listUsersBtnEvaluacion: any[] = []; // ÁREA RIESGO
  userEvaluacionValid: boolean = false; // ÁREA RIESGO
  listUsersBtnAceptar: any[] = []; // GERALDINE VEGA, SHEYLLA
  userAceptacionValid: boolean = false;
  formObservaciones: FormGroup;
  contadorDoc: number = 0;
  relacionDNF: boolean;
  user_id:any;
  subLista: Subscription[] = [];
  subPropOperacion: Subscription = new Subscription();
  subPropOperacionDet: Subscription = new Subscription();
  subProspecto: Subscription = new Subscription();
  subItemsPropOperacion: Subscription = new Subscription();
  subContratoMarco: Subscription = new Subscription();
  subEmpresa: Subscription = new Subscription();
  subPagareProv: Subscription = new Subscription();
  subPagareAdq: Subscription = new Subscription();
  subActualizacionPropOp: Subscription = new Subscription();
  subDocNegociable: Subscription = new Subscription();
  subObservacionPropOp: Subscription = new Subscription();
  subParametros: Subscription = new Subscription();

  sectores: any = [];
  fondos: any = [];
  garantias: any = [];
  comprobante: any;
  VNPP: any;
  panelOpenState = true;
  proformas: any = [];
  solicitudDesembolso: any = [];
  solicitudDesembolsoLoaded: boolean = false;
  proformaLoaded: boolean = false;
  DTOFiltrosSolicitudDes: FiltrosSolicitudDes = new FiltrosSolicitudDes();
  arraySend: any = [];
  listaDN: any = [];
  flag: any;
  listUsersBtnAsignar: any[] = []; // ÁREA RIESGO
  userAsignarValid: boolean = false;
  listUsersBtnEditar: any[] = []; // Ruth ,waldir
  userEditarValid: boolean = false;
  listUsersBtnVer: any[] = []; // ÁREA RIESGO y Ruth, Waldir
  userVerValid: boolean = false;

  dataEnviar: any = {};
  empresasService: EmpresasService;
  prospectoService: ProspectosService;
  propuestaOperacionService: PropuestaOperacionService;
  securityService: SecurityService;
  proformaService: ProformaService;
  loginService: LoginService;
  riesgoService: RiesgoService;
  solicitudDesembolsoService: SolicitudDesembolsoService;

  lineaMonedaSimbolo: string;
  colorLineaAdmitida: string;
  colorLineaUtilizada: string;
  colorLineaDisponible: string;
  readonly COLOR_MONTO_POSITIVO = '#23af23';
  readonly COLOR_MONTO_CERO = '#1da0ec';
  readonly COLOR_MONTO_NEGATIVO = '#ff5454';

  constructor(
    private injector: Injector,
    private msgTitle: MessagesTitles,
    private msgStatus: MessagesStatus,
    private datePipe: DatePipe,
    private router: Router
  ) {
    this.colorLineaAdmitida = this.COLOR_MONTO_CERO;
    this.colorLineaUtilizada = this.COLOR_MONTO_CERO;
    this.colorLineaDisponible = this.COLOR_MONTO_CERO;

    this.empresasService = this.injector.get<EmpresasService>(EmpresasService);
    this.prospectoService = this.injector.get<ProspectosService>(ProspectosService);
    this.propuestaOperacionService = this.injector.get<PropuestaOperacionService>(PropuestaOperacionService);
    this.securityService = this.injector.get<SecurityService>(SecurityService);
    this.proformaService = this.injector.get<ProformaService>(ProformaService);
    this.loginService = this.injector.get<LoginService>(LoginService);
    this.riesgoService = this.injector.get<RiesgoService>(RiesgoService);
    this.solicitudDesembolsoService = this.injector.get<SolicitudDesembolsoService>(SolicitudDesembolsoService);

    this.DTOFiltrosProspecto.FechaIni = '1991-01-01';
    this.DTOFiltrosProspecto.FechaFin = this.datePipe.transform(moment(), 'yyyy-MM-dd');

    if (!this.proformaService.datosPropuestaInformacion) {
      this.loginService.clickGuard = true;
      this.router.navigate(["/operaciones/propuesta-operacion/listado"]);
    }

    this.idPropuestaOperacion = this.proformaService.datosPropuestaInformacion.idPropuestaOperacion;
    this.estadoPropuesta = this.proformaService.datosPropuestaInformacion.Estado;
    this.flagEvaluacion = this.proformaService.flagEvaluacion;

    this.user = JSON.parse(sessionStorage.getItem('UserActive'));

    this.subParametros = this.securityService.ObtenerParametros(this.user.id_empresa).subscribe(
      (res: any) => {

        for (const iterator of res) {
          switch (iterator.Codigo) {
            case 'USER_ACEPTAR_PROPUESTA_OPERACION':
              this.listUsersBtnAceptar = this.obtenerValoresXCodigo(iterator.Valor);
              break;
            case 'USER_EVAL_PROPUESTA_OPERACION':
              this.listUsersBtnEvaluacion = this.obtenerValoresXCodigo(iterator.Valor);
              break;
            case 'USER_ASIGNAR_FONDO_DOC_NEG':
              this.listUsersBtnAsignar = this.obtenerValoresXCodigo(iterator.Valor);
              break;
            case 'USER_EDITAR_FONDO_DOC_NEG':
              this.listUsersBtnEditar = this.obtenerValoresXCodigo(iterator.Valor);
              break;
            case 'USER_VER_FONDO_DOC_NEG':
              this.listUsersBtnVer = this.obtenerValoresXCodigo(iterator.Valor);
              break;
            default:
              break;
          }
        }
        this.userAceptacionValid = this.listUsersBtnAceptar.includes(this.user.Usuario);
        this.userEvaluacionValid = this.listUsersBtnEvaluacion.includes(this.user.Usuario);
        this.userAsignarValid = this.listUsersBtnAsignar.includes(this.user.Usuario);
        this.userEditarValid = this.listUsersBtnEditar.includes(this.user.Usuario);
        this.userVerValid = this.listUsersBtnVer.includes(this.user.Usuario);
      },
      () => {
        this.listUsersBtnAceptar = [];
        this.userAceptacionValid = false;
        this.listUsersBtnEvaluacion = [];
        this.userEvaluacionValid = false;
        this.listUsersBtnAsignar = [];
        this.userAsignarValid = false;
        this.listUsersBtnEditar = [];
        this.userEditarValid = false;
        this.listUsersBtnVer = [];
        this.userVerValid = false;
      }
    );

    this.subLista.push(this.subParametros);

    this.formObservaciones = new FormGroup({
      idPropuestaOperacion: new FormControl(''),
      Usuario: new FormControl(''),
      NombreCompleto: new FormControl(''),
      RolUsuario: new FormControl(''),
      Observacion: new FormControl('')
    });

    this.formEvaluacion = new FormGroup({
      idPropuestaOperacion: new FormControl(),
      idProspecto: new FormControl(null),
      Estado: new FormControl(''),
      idProveedor: new FormControl(''),
      idAdquirente: new FormControl(''),
      NombreProveedor: new FormControl(''),
      NombreAdquirente: new FormControl(''),
      Num_Doc_Identificacion_Adq: new FormControl(''),
      Num_Doc_Identificacion_Prov: new FormControl(''),
      Alta_Usuario_Riesgo: new FormControl(this.user.Usuario),
      Nombre_Usuario_Riesgo: new FormControl(this.user.Nombre),
      Nombre_Usuario_Comercial: new FormControl(''),
      Email_Usuario_Riesgo: new FormControl(this.user.Email),
      Observaciones_Propuesta: new FormControl(''),
      itemsProspectoEvaluacion: new FormControl(this.arrProspectoPropuestaOperacion),
      docNegociables: new FormControl(''),
      opcion: new FormControl('')
    });
  }

  ngOnInit() {
    this.cargaListados();
    this.listarGarantias();
    this.listarSectores();
  }

  ngOnDestroy() {
    this.subLista.forEach(sub => { sub.unsubscribe(); });
  }

  obtenerValoresXCodigo(parametro: string) {
    if (parametro.includes(',')) {
      return parametro.split(',');
    } else {
      return [parametro.trim()];
    }
  }

  cargaListados() {
    this.ObtenerPropuestaOperacion(this.idPropuestaOperacion);
    this.ObtenerPropuestaOperacionDetalle(this.idPropuestaOperacion);
    this.obtenerComentariosPropuestaOperacion(this.idPropuestaOperacion);

    if (this.flagEvaluacion && this.estadoPropuesta == 'P') {
      this.obtenerItemsProspecto();
    } else if (this.flagEvaluacion && this.estadoPropuesta == 'O') {
      this.obtenerItemsProspecto(this.idPropuestaOperacion);
    }
  }
  refresh() {
    this.arraySend = [];
    this.VNPPTotal = 0;
    this.contadorDoc = 0
    this.bodyActualizacionDocumentos = [];
    this.ObtenerPropuestaOperacionDetalle(this.idPropuestaOperacion);
    this.VNPP = 0;
    this.adelantoTotal = 0;
    this.interesTotal = 0;
    this.comisionTotal = 0;
    this.IGVTotal = 0;
    this.desembolsoTotal = 0;
    this.remanenteTotal = 0;
  }

  refreshProspecto() {
    this.prospectos = [];
    this.prospectoLoaded = false;
    this.obtenerProspecto();
  }

  ObtenerPropuestaOperacion(idPropuestaOp: number) {
    this.loading = true;

    this.subPropOperacion = this.propuestaOperacionService.ObtenerPropuestaOperacionPorId(idPropuestaOp).subscribe(
      (resPropuesta: any) => {

        this.PropuestaOperacion = resPropuesta[0];
        this.PropuestaOperacion.Tipo_Documento = this.PropuestaOperacion.Tipo_Documento.toUpperCase();
        this.PropuestaOperacion.Nombre_Usuario_Comercial = this.PropuestaOperacion.Nombre_Usuario_Comercial.toUpperCase();

        this.formatMonedaYMontosLineaAdq(this.PropuestaOperacion);

        this.obtenerProspecto();
        this.obtenerContratosMarco(this.PropuestaOperacion.idProveedor, this.PropuestaOperacion.Tipo_Servicio);
        this.obtenerPagaresAdq();
        this.obtenerPagaresProv();
        this.obtenerDocumentoAdjuntos();

        this.ListadoProforma();
        this.ListadoSolicitudDesembolso();
        this.listarFondos();

      },
      (err: HttpErrorResponse) => {

        this.loading = false;
        Swal.fire({
          title: "Ha ocurrido un error",
          text: err.error.error,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });

      }
    );

    this.subLista.push(this.subPropOperacion);
  }

  formatMonedaYMontosLineaAdq(propuesta: PropuestaOperacion) {
    if (propuesta.Moneda == this.Label_id_soles) {
      this.lineaMonedaSimbolo = 'S/ ';
    } else if (propuesta.Moneda == this.Label_id_dolares) {
      this.lineaMonedaSimbolo = '$ ';
    } else {
      this.lineaMonedaSimbolo = '';
    }

    propuesta.LineaAdmitida = propuesta.LineaAdmitida != null ? propuesta.LineaAdmitida : null;
    propuesta.LineaUtilizada = propuesta.LineaUtilizada != null ? propuesta.LineaUtilizada : null;
    propuesta.LineaDisponible = propuesta.LineaDisponible != null ? propuesta.LineaDisponible : null;

    this.colorLineaAdmitida = this.setColorMontosLineas(propuesta.LineaAdmitida);
    this.colorLineaUtilizada = this.setColorMontosLineas(propuesta.LineaUtilizada);
    this.colorLineaDisponible = this.setColorMontosLineas(propuesta.LineaDisponible);
  }

  setColorMontosLineas(monto: number): string {
    if (monto > 0.00) {
      return '#1bce1b';
    } else if (monto == 0.00) {
      return '#1d43ec';
    } else {
      return '#f14a4a';
    }
  }

  ObtenerPropuestaOperacionDetalle(idPropuestaOp: number) {
    this.loading = true;

    this.subPropOperacionDet = this.propuestaOperacionService.ObtenerPropuestaOperacionDetallePorId(idPropuestaOp).subscribe(
      (resPropuestaDet: any) => {
        this.loading = false;
        this.PropuestaOperacionDetalle = resPropuestaDet;
        this.PropuestaOperacionDetalle.forEach(pod => {
          pod.VNPP = Number(pod.VNPP);
          if (pod.Estado === 'Registrado' || pod.Estado === 'En Evaluacion') {
            pod.checked = false;
          } else {
            pod.checked = true;
            this.contadorDoc++;
            this.VNPPTotal += pod.VNPP;
            if (this.estadoPropuesta == 'X' || this.estadoPropuesta == 'D') {
              this.adelantoTotal += Number(pod.Adelanto_importe);
              this.interesTotal += Number(pod.Interes_importe);
              this.comisionTotal += Number(pod.Comision_importe);
              this.IGVTotal += Number(pod.IGV_Importe);
              this.desembolsoTotal += Number(pod.Desembolso_importe);
              this.remanenteTotal += Number(pod.Remanente_importe);
            }
            this.arraySend.push(pod); // SE USA PARA MANEJO DE FONDOS
          }

          this.bodyActualizacionDocumentos.push({ "idComprobante": String(pod.idComprobante), "Estado": "", "checked": pod.checked });
        });
      },
      (err1: HttpErrorResponse) => {

        this.loading = false;
        Swal.fire({
          title: "Ha ocurrido un error",
          text: err1.error.error,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });

      }
    );

    this.subLista.push(this.subPropOperacionDet);
  }

  obtenerProspecto() {
    this.DTOFiltrosProspecto.FechaIni = this.datePipe.transform(this.DTOFiltrosProspecto.FechaIni, 'yyyy-MM-dd');
    this.DTOFiltrosProspecto.FechaFin = this.datePipe.transform(this.DTOFiltrosProspecto.FechaFin, 'yyyy-MM-dd');
    this.DTOFiltrosProspecto.Version = 2;
    this.subProspecto = this.prospectoService.obtenerProspectoCab(this.DTOFiltrosProspecto).subscribe(
      (resp: ProspectoCab[]) => {
        this.prospectos = resp;

        this.prospectos = this.prospectos.filter(
          p => p.idProspecto == this.PropuestaOperacion.idProspecto && p.idPropuestaOperacion == this.PropuestaOperacion.idPropuestaOperacion
        );
        this.prospectoLoaded = true;
        this.loading = false;
      },
      (err2: HttpErrorResponse) => {
        this.loading = false;
        Swal.fire({
          title: "Ha ocurrido un error",
          text: err2.error.error,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      }
    );

    this.subLista.push(this.subProspecto);
  }

  obtenerItemsProspecto(idPropuestaOperacion?: number) {
    this.subItemsPropOperacion = this.propuestaOperacionService.obtenerItemsPropuestaOperacion(idPropuestaOperacion).subscribe(
      (resItemsProspecto: ItemsProspecto[]) => {
        this.itemsProspecto = resItemsProspecto;
        this.itemProspectoOtros = this.itemsProspecto.find((ipo: ItemsProspecto) => ipo.Nombre_Item == 'Otros');
        this.itemsProspecto = this.itemsProspecto.filter((ip: ItemsProspecto) => ip.Estado == 'A' && ip.Nombre_Item != 'Otros');
        this.itemsProspecto.forEach(p => {
          p.placeholderItem = 'Observaciones para '.concat(p.Nombre_Item.toLowerCase());
          if (idPropuestaOperacion) {
            p.checked = Boolean(p.checked);
          }
          this.arrProspectoPropuestaOperacion.push(p);
        })
        if (this.itemProspectoOtros != undefined) {
          this.itemProspectoOtros.placeholderItem = 'Observaciones adicionales';
          if (idPropuestaOperacion) {
            setTimeout(() => {
              this.observacionesItem.nativeElement.value = this.itemProspectoOtros.Observaciones;
            }, 300);
          }
          this.arrProspectoPropuestaOperacion.push(this.itemProspectoOtros);
        }

        this.itemsProspecto.forEach(el => {
          this.contadorItemsSeleccionados = el.checked ? this.contadorItemsSeleccionados++ : 0;
        });
        this.contadorItemsSeleccionados = this.itemProspectoOtros.checked ? this.contadorItemsSeleccionados++ : 0;
      },
      (err: HttpErrorResponse) => {

        Swal.fire({
          title: "Ha ocurrido un error",
          text: err.error.error,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });

      }
    );

    this.subLista.push(this.subItemsPropOperacion);
  }

  obtenerContratosMarco(idEmpresa, tipoServicio) {
    this.subContratoMarco = this.empresasService.obtenerContratosMarco(idEmpresa, tipoServicio).subscribe(
      (resContratosMarco: any) => {
        this.contratoMarco = resContratosMarco.filter(ip => ip.Estado == 'A' || ip.Estado == 'E');
        this.contratoMarco1 = this.contratoMarco ? this.contratoMarco[0] : [];

        if (this.contratoMarco1 == undefined) {
          this.contratoMarco1 = [];
        }
        this.contratoMarcoLoaded = true;
        this.loading = false;

      },
      (err: HttpErrorResponse) => {

        this.contratoMarcoLoaded = true;
        this.loading = false;
        if (err.error.code == 500) {
          err.error.error = "Problemas con el sistema, por favor contactarse con soporte"
        }
        Swal.fire({
          title: "Ha ocurrido un error",
          text: err.error.error,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });

      }
    );

    this.subLista.push(this.subContratoMarco);
  }

  obtenerDocumentoAdjuntos() {
    this.subEmpresa = this.empresasService.obtenerAdjuntosEmpresa(this.PropuestaOperacion.idProveedor).subscribe(
      (resDocAdjuntos: any) => {

        this.documentosAdjuntos = resDocAdjuntos;
        this.documentosAdjuntos = this.documentosAdjuntos.filter(doc => doc.Estado == 'A');
        this.adjuntosLoaded = true;

      },
      (err: HttpErrorResponse) => {

        this.adjuntosLoaded = true;
        this.msgStatus.getMessage(err.status);
        Swal.fire({
          title: this.msgTitle.Error,
          text: "ADJUNTOS NO OBTENIDO. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });

      }
    );

    this.subLista.push(this.subEmpresa);
  }

  obtenerPagaresAdq() {
    const TIPO_SERVICIO_PAGARE_ADQUIRENTE = this.Id_Confirming;
    if (!this.fechaIni) {
      this.fechaIni = 0
    }
    if (!this.fechaFin) {
      this.fechaFin = 0
    }
    this.subPagareAdq = this.empresasService.ListadoPagares(this.PropuestaOperacion.idAdquirente, TIPO_SERVICIO_PAGARE_ADQUIRENTE, this.fechaIni, this.fechaFin).subscribe(
      (res: any) => {
        this.pagareAdq = res;
        this.pagareAdq = this.pagareAdq.filter(state => state.RazonSocialEmpresa != null && state.Estado == "A");
        this.pagareAdqLoaded = true;
      }, err => {
        Swal.fire({
          title: "!Algo salió mal!",
          text: err.error['error'],
          type: "warning",
          allowOutsideClick: true,
          heightAuto: false
        });
        this.pagareAdqLoaded = true;
      }
    );

    this.subLista.push(this.subPagareAdq);
  }

  obtenerPagaresProv() {
    const TIPO_SERVICIO_PAGARE_PROVEEDOR = this.Id_Factoring;
    if (!this.fechaIni) {
      this.fechaIni = 0
    }
    if (!this.fechaFin) {
      this.fechaFin = 0
    }

    this.subPagareProv = this.empresasService.ListadoPagares(this.PropuestaOperacion.idProveedor, TIPO_SERVICIO_PAGARE_PROVEEDOR, this.fechaIni, this.fechaFin).subscribe(
      (res: any) => {
        this.pagareProv = res;
        this.pagareProv = this.pagareProv.filter(state => state.RazonSocialEmpresa != null && state.Estado == "A");
        this.pagareProvLoaded = true;
      }, err => {
        Swal.fire({
          title: "!Algo salió mal!",
          text: err.error['error'],
          type: "warning",
          allowOutsideClick: true,
          heightAuto: false
        });
        this.pagareProvLoaded = true;
      }
    );

    this.subLista.push(this.subPagareProv);
  }

  verAdjunto(url: string) {
    window.open(url, '_blank');
  }

  abrirProspecto(prospecto: ProspectoRiesgo, vnppTotal: number) {
    this.prospecto = prospecto;
    this.prospecto.edit = false;
    this.prospecto.propuesta = true;
    this.prospecto.vnppTotal = vnppTotal;
    this.flagEvaluarProspecto = true;
  }

  metCerrarEvaluacionProspecto() {
    this.flagEvaluarProspecto = false;
    this.flagEditarProspecto = false;
    this.prospecto.propuesta = false;
    this.prospecto.edit = false;
  }

  cerrarPopUp() {
    this.relacionDNF = false;
  }

  abrirRelacionDNF(comprobante, flag) {
    this.flag = flag;

    if (flag == 'add') {
      if (this.arraySend.length == 0) {
        Swal.fire({
          title: '¡Atención!',
          text: 'Debe seleccionar por lo menos 1 documento negociable para asignar su Fondo',
          type: 'warning',
          heightAuto: false
        });
        return;
      }
      this.listaDN = this.arraySend;
      this.relacionDNF = true;

    } else if (flag == 'edit') {
      if (this.arraySend.length == 0) {
        Swal.fire({
          title: '¡Atención!',
          text: 'Debe seleccionar por lo menos 1 documento negociable para editar su Fondo',
          type: 'warning',
          heightAuto: false
        });
        return;
      }
      for (let item of this.arraySend) {
        if (item.cantidad_fondos_financiados == 0) {
          Swal.fire({
            title: '¡Atención!',
            text: 'Comprobante N° ' + item.idComprobante + ' no tiene asignado fondo',
            type: 'warning',
            heightAuto: false
          });
          return;
        }
      }
      this.listaDN = this.arraySend;
      this.relacionDNF = true;

    } else {
      this.comprobante = comprobante;
      this.relacionDNF = true;
    }
  }

  retirarDNFondo() {
    if (this.arraySend.length == 0) {
      Swal.fire({
        title: '¡Atención!',
        text: 'Debe seleccionar por lo menos 1 documento negociable para retirar del fondo',
        type: 'warning',
        heightAuto: false
      });
      return;
    }
    for (let item of this.arraySend) {
      if (item.cantidad_fondos_financiados_activos == 0) {
        Swal.fire({
          title: '¡Atención!',
          text: 'Comprobante N° ' + item.idComprobante + ' no tiene fondo activo',
          type: 'warning',
          heightAuto: false
        });
        return;
      }
    }

    const arrayidComprobante = this.arraySend.map(item => {
      return item.idComprobante
    });

    Swal.fire({
      title: 'Advertencia',
      text: '¿Está seguro de retirar el fondo del documento negociable:' + arrayidComprobante + '?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, retirar',
      cancelButtonText: 'No, cancelar.',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        this.dataEnviar.Comprobantes = []
        this.dataEnviar.Usuario = this.user.Usuario;

        for (let item of this.arraySend) {
          this.dataEnviar.Comprobantes.push({
            'idComprobante': item.idComprobante,
            'Estado': 'R'
          })
        }
        Swal.fire({
          title: 'Espere',
          text: 'Enviando información.',
          type: 'info',
          heightAuto: false
        });
        Swal.showLoading();

        this.riesgoService.retirarFondoDN(this.dataEnviar)
          .subscribe(res => {
            Swal.fire({
              title: '¡Éxito!',
              text: 'Fondo retirado',
              type: 'success',
              heightAuto: false
            }).then(resp => {
              if (resp.value) {
                this.refresh();
              }
            });

          }, (err: HttpErrorResponse) => {
            this.msgStatus.getMessage(err.status);
            Swal.fire({
              title: "Error",
              text: "FONDO NO RETIRADO. " + this.msgStatus.message,
              type: "error",
              allowOutsideClick: true,
              heightAuto: false
            })
          })
      }
    })

  }

  evaluarPropuestaOperacion(tipoOperacion: string) {
    if (tipoOperacion != 'R' && this.contadorDoc == 0) {
      Swal.fire({
        title: '¡Atención!',
        text: 'Debe seleccionar por lo menos 1 documento negociable para continuar con la evaluación de la propuesta de operación.',
        type: 'error',
        heightAuto: false
      });
      return;
    }

    let textSwal = "";
    if (tipoOperacion == 'A') {
      textSwal = '¿Aceptar la propuesta de operación?';
    } else if (tipoOperacion == 'R') {
      textSwal = '¿Rechazar la propuesta de operación?';
    } else {
      textSwal = '¿Calificar la propuesta de operación?';
    }
    Swal.fire({
      title: '',
      text: textSwal,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si',
      cancelButtonText: 'No',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {

        this.armarBodyEvaluacion(tipoOperacion);

        Swal.fire({
          title: '¡Espere!',
          html: 'Procesando solicitud.',
          heightAuto: false
        });
        Swal.showLoading();

        this.subActualizacionPropOp = this.propuestaOperacionService.ActualizarPropuestaOperacion(this.formEvaluacion.getRawValue()).subscribe(
          () => {

            Swal.fire({
              title: '¡Evaluación completada!',
              text: '¡La propuesta de operación ha sido evaluada!',
              type: 'success',
              heightAuto: false
            }).then((result1) => {
              if (result1.value) {
                this.loginService.clickGuard = true;
                this.router.navigate(["/operaciones/propuesta-operacion/listado"]);
              }
            });

          },
          (err3: HttpErrorResponse) => {

            Swal.fire({
              title: "Ha ocurrido un error",
              text: err3.error.error,
              type: "error",
              allowOutsideClick: false,
              heightAuto: false
            });

          }
        );

        this.subLista.push(this.subActualizacionPropOp);
      }
    });
  }

  cambiarEstadoItem(item) {
    this.arrProspectoPropuestaOperacion.forEach(elemento => {
      if (elemento.idItemsProspecto == item.idItemsProspecto) {
        elemento.checked = elemento.checked ? false : true;

        if (elemento.checked) {
          this.contadorItemsSeleccionados++;
        } else {
          this.contadorItemsSeleccionados--;
        }
      }
    });
  }

  cambiarEstadoItemOtros() {
    this.arrProspectoPropuestaOperacion.forEach(elemento1 => {
      if (elemento1.idItemsProspecto == this.itemProspectoOtros.idItemsProspecto) {
        elemento1.checked = elemento1.checked ? false : true;
        elemento1.Observaciones = this.itemProspectoOtros.Observaciones;

        if (elemento1.checked) {
          this.contadorItemsSeleccionados++;
        } else {
          this.contadorItemsSeleccionados--;
        }
      }
    });
  }

  seleccionarDocumentosNeg(doc: any) {
    if (doc.checked) {
      this.arraySend.push(doc);
    } else {
      this.arraySend = this.arraySend.filter(function (dato) {
        if (dato.idComprobante == doc.idComprobante) {
          return false;
        } else {
          return true;
        }
      })
    }
    this.bodyActualizacionDocumentos.forEach(documento => {
      if (documento.idComprobante == doc.idComprobante) {
        documento.checked = !documento.checked;
        if (documento.checked) {
          this.contadorDoc++;
          this.VNPPTotal += doc.VNPP;
        } else {
          this.contadorDoc--;
          this.VNPPTotal -= doc.VNPP;
        }
      }
    });
  }

  armarBodyEvaluacion(tipoOperacion) {
    let estadoProspecto = 'O';

    if (tipoOperacion == 'A') {
      estadoProspecto = 'A';
    } else if (tipoOperacion == 'R') {
      estadoProspecto = 'R';
    }

    let arrFinal: ItemsProspectoPropuestaOperacion[] = this.armarItems();

    this.formEvaluacion.get('idPropuestaOperacion').setValue(this.PropuestaOperacion.idPropuestaOperacion);
    this.formEvaluacion.get('idProspecto').setValue(this.PropuestaOperacion.idProspecto ? this.PropuestaOperacion.idProspecto : null);
    this.formEvaluacion.get('itemsProspectoEvaluacion').setValue(arrFinal);
    this.formEvaluacion.get('Estado').setValue(estadoProspecto);
    this.formEvaluacion.get('NombreAdquirente').setValue(this.PropuestaOperacion.NombreAdquirente);
    this.formEvaluacion.get('Nombre_Usuario_Comercial').setValue(this.PropuestaOperacion.Nombre_Usuario_Comercial);
    this.formEvaluacion.get('idProveedor').setValue(this.PropuestaOperacion.idProveedor);
    this.formEvaluacion.get('NombreProveedor').setValue(this.PropuestaOperacion.NombreProveedor);
    this.formEvaluacion.get('idAdquirente').setValue(this.PropuestaOperacion.idAdquirente);
    this.formEvaluacion.get('Num_Doc_Identificacion_Adq').setValue(this.PropuestaOperacion.Num_Doc_Identificacion_Adq);
    this.formEvaluacion.get('Num_Doc_Identificacion_Prov').setValue(this.PropuestaOperacion.Num_Doc_Identificacion_Prov);

    if (this.formEvaluacion.get('Estado').value == 'R') {
      this.PropuestaOperacionDetalle.forEach(el => { el.checked = true });
      this.bodyActualizacionDocumentos.forEach(el => {
        el.Estado = "R";
        el.checked = true;
      });
    } else if (this.formEvaluacion.get('Estado').value == 'A') {
      this.bodyActualizacionDocumentos.forEach(el => {
        el.Estado = el.checked ? "A" : "R";
      });
    } else if (this.formEvaluacion.get('Estado').value == 'O') {
      this.bodyActualizacionDocumentos.forEach(el => {
        el.Estado = el.checked ? "V" : "R";
      });
    }

    this.formEvaluacion.get('docNegociables').setValue(this.armarBodyDocumentos());
  }

  armarBodyDocumentos() {
    let bodyDocEmail = [];
    this.bodyActualizacionDocumentos.forEach(doc => {
      this.PropuestaOperacionDetalle.forEach(docDetalle => {
        if (doc.idComprobante == docDetalle.idComprobante) {
          if (doc.checked) {
            bodyDocEmail.push({
              idComprobante: docDetalle.idComprobante,
              Tipo_Comprobante: docDetalle.Tipo_Comprobante,
              Serie: docDetalle.Serie,
              Numero: docDetalle.Numero,
              VNPP: docDetalle.VNPP,
              Estado: doc.Estado
            });
          }
        }
      });
    });

    return bodyDocEmail;
  }

  armarItems() {
    let arrFinal: ItemsProspectoPropuestaOperacion[] = [];
    this.arrProspectoPropuestaOperacion.forEach(item => {
      if (item.Nombre_Item == "Otros") item.Observaciones = this.observacionesItem.nativeElement.value;
      this.iProspectoPropuestaOperacion = new ItemsProspectoPropuestaOperacion();
      this.iProspectoPropuestaOperacion.Id_IPPO = item.Id_IPPO;
      this.iProspectoPropuestaOperacion.idPropuestaOperacion = this.PropuestaOperacion.idPropuestaOperacion;
      this.iProspectoPropuestaOperacion.idItemsProspecto = item.idItemsProspecto;
      this.iProspectoPropuestaOperacion.Observaciones = item.Observaciones;
      this.iProspectoPropuestaOperacion.checked = item.checked == undefined ? false : item.checked;
      arrFinal.push(this.iProspectoPropuestaOperacion);
    });
    return arrFinal;
  }

  agregarComentario() {
    let comentario: string = this.formEvaluacion.get('Observaciones_Propuesta').value;
    if (comentario.trim().length == 0) {
      Swal.fire({
        title: 'Atención',
        text: 'La caja de comentarios está vacía.',
        type: 'error',
        heightAuto: false
      });
    } else {
      Swal.fire({
        title: 'Atención',
        text: '¿Desea agregar un comentario?',
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        reverseButtons: true,
        heightAuto: false
      }).then((result) => {
        if (result.value) {

          Swal.fire({
            title: '¡Espere!',
            html: 'Registrando el comentario...',
            heightAuto: false
          });
          Swal.showLoading();

          this.formObservaciones.patchValue({
            idPropuestaOperacion: this.idPropuestaOperacion,
            Usuario: this.user.Usuario,
            NombreCompleto: this.user.Nombre,
            RolUsuario: this.user.id_roles ? this.user.id_roles : null,
            Observacion: this.formEvaluacion.get('Observaciones_Propuesta').value
          });

          this.comentariosLoaded = false;
          this.propuestaOperacionService.CrearObservacionesPropuestaOperacion(this.formObservaciones.getRawValue()).subscribe(
            () => {
              Swal.fire({
                title: '¡Exito!',
                text: '¡Su comentario ha sido registrado correctamente!',
                type: 'success',
                heightAuto: false
              });
              this.observacionesFinal = [];
              this.formEvaluacion.get('Observaciones_Propuesta').setValue('');
              this.formObservaciones.reset();
              this.obtenerComentariosPropuestaOperacion(this.idPropuestaOperacion);
            },
            () => {
              this.comentariosLoaded = true;
            }
          );

        }
      });
    }

  }

  listarFondos() {
    this.riesgoService.obtenerFondos().subscribe(
      resp => {
        this.fondos = resp
        this.fondos = this.fondos.filter(item => item.Moneda == this.PropuestaOperacion.Moneda || item.Multiples_Moneda == 'A');
      }, (err: HttpErrorResponse) => {
        this.loading = false;
        this.msgStatus.getMessage(err.status);
        Swal.fire({
          title: 'error',
          text: "LISTA FONDOS NO OBTENIDO. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false
        });
      });
  }
  listarGarantias() {
    this.riesgoService.ListarGarantias().subscribe(
      resp => {
        this.garantias = resp
      }, (err: HttpErrorResponse) => {
        this.loading = false;
        this.msgStatus.getMessage(err.status);
        Swal.fire({
          title: 'error',
          text: "LISTA GARANTIAS NO OBTENIDO. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false
        });
      });
  }

  listarSectores() {
    this.riesgoService.ListarSectores().subscribe(
      resp => {
        this.sectores = resp
      }, (err: HttpErrorResponse) => {
        this.loading = false;
        this.msgStatus.getMessage(err.status);
        Swal.fire({
          title: 'error',
          text: "LISTA SECTORES NO OBTENIDO. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false
        });
      });
  }

  obtenerComentariosPropuestaOperacion(idPropuestaOperacion: number) {
    this.comentariosLoaded = false;
    this.subObservacionPropOp = this.propuestaOperacionService.ObtenerObservacionesPropuestaOperacion(idPropuestaOperacion).subscribe(
      (resObservaciones: any) => {
        this.observacionesFinal = resObservaciones;
        this.comentariosLoaded = true;
      },
      () => {
        this.comentariosLoaded = true;
      }
    );

    this.subLista.push(this.subObservacionPropOp);
  }

  ListadoProforma() {
    /*this.user_id=Buffer.from(this.user.id_user.toString()).toString('base64');*/
    this.user_id= this.user.id_user;
    this.proformaService.obtenerProformas(this.PropuestaOperacion.Num_Doc_Identificacion_Adq, this.PropuestaOperacion.Num_Doc_Identificacion_Prov, '', '1990-01-01', '1990-01-01',this.user_id).subscribe(
      // this.proformaService.obtenerProformas('10474814594', '10462922154', '','1990-01-01','1990-01-01').subscribe( //datos de prueba
      (res: any) => {
        this.proformas = res;
        this.proformaLoaded = true;
      },
      err => {
        let mensaje = "ERROR";
        this.proformaLoaded = true;
        Swal.fire({
          title: "¡Algo salió mal!",
          text: mensaje,
          type: "warning",
          allowOutsideClick: true,
          heightAuto: false
        });
      }
    );

  }

  ListadoSolicitudDesembolso() {
    this.DTOFiltrosSolicitudDes.Estado = '';
    this.DTOFiltrosSolicitudDes.IdAd = this.PropuestaOperacion.idAdquirente;
    this.DTOFiltrosSolicitudDes.IdProv = this.PropuestaOperacion.idProveedor;
    this.solicitudDesembolsoService.FiltroListadoSoliDes(this.DTOFiltrosSolicitudDes, '1990-01-01', '1990-01-01').subscribe(
      (res: any) => {
        this.solicitudDesembolso = res;
        this.solicitudDesembolsoLoaded = true;
      },
      err => {
        let mensaje = "ERROR";
        this.solicitudDesembolsoLoaded = true;
        Swal.fire({
          title: "¡Algo salió mal!",
          text: mensaje,
          type: "warning",
          allowOutsideClick: true,
          heightAuto: false
        });
      }
    );

  }

}